/** Neon rave color palette */
export const NeonColors = {
  MAGENTA: 0xff00ff,
  CYAN: 0x00ffff,
  LIME: 0x00ff00,
  PINK: 0xff1493,
  ORANGE: 0xff6600,
  PURPLE: 0x9900ff,
  BLUE: 0x0066ff,
  RED: 0xff0033,
  YELLOW: 0xffff00,
  WHITE: 0xffffff,
} as const;

export const NEON_PALETTE = [
  NeonColors.MAGENTA,
  NeonColors.CYAN,
  NeonColors.LIME,
  NeonColors.PINK,
  NeonColors.ORANGE,
  NeonColors.PURPLE,
  NeonColors.BLUE,
];

/** Convert a 0xRRGGBB number to CSS hex string */
export function colorToHex(color: number): string {
  return '#' + color.toString(16).padStart(6, '0');
}

/** Lerp between two colors */
export function lerpColor(a: number, b: number, t: number): number {
  const ar = (a >> 16) & 0xff;
  const ag = (a >> 8) & 0xff;
  const ab = a & 0xff;
  const br = (b >> 16) & 0xff;
  const bg = (b >> 8) & 0xff;
  const bb = b & 0xff;
  const r = Math.round(ar + (br - ar) * t);
  const g = Math.round(ag + (bg - ag) * t);
  const bl = Math.round(ab + (bb - ab) * t);
  return (r << 16) | (g << 8) | bl;
}
